import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button, Text, Tooltip } from 'lusha-ui-components-v2';
import { showPopup } from 'lusha-widgets';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { IconFactory } from '../../assets/icons/IconFactory';
import DescriptionInfo from '../DescriptionInfo';
import './Notification.scss';
export const INDICATION = {
    SUCCESS: 'Success',
    FAIL: 'Fail',
    BLUE_FAIL: 'BlueFail',
};
function Notification(props) {
    const { closeToast, indication, message, description, action, onClick, title, className, btnVariant, onCloseClick, descriptionInTooltip, showOverflow, creditsCharged, } = props;
    function onAction(e) {
        onClick(e);
    }
    function onCloseClickWrapper() {
        if (onCloseClick) {
            onCloseClick();
            closeToast();
        }
        else {
            closeToast();
        }
    }
    const onDescriptionClick = useCallback(() => {
        if (!descriptionInTooltip) {
            showPopup(DescriptionInfo, { title, descriptionText: description });
        }
    }, [title, description, descriptionInTooltip]);
    return (_jsxs("div", { className: `notification-container ${className}`, children: [_jsx("div", { className: "notification-indication", children: IconFactory(`${indication}Indication`) }), _jsxs("div", { className: `notification-content ${action && onClick ? 'short' : 'long'}`, children: [_jsx(Text, { className: showOverflow ? 'notification-message-show-overflow' : 'notification-message', variant: "tinyR", color: "seriousBlack", children: message }), description && (_jsx("span", { onClick: onDescriptionClick, "data-tip": true, "data-for": "notification-description-tooltip", className: "notification-description-icon", children: IconFactory('Info') })), description && descriptionInTooltip && (_jsx(Tooltip, { id: "notification-description-tooltip", place: "bottom", maxWidth: "200", children: description })), creditsCharged !== undefined && creditsCharged !== null && (_jsxs("span", { className: "notification-credits-charged", children: [IconFactory('Credit'), creditsCharged] }))] }), _jsxs("div", { className: "notification-actions", children: [action && onClick && (_jsx(Button, { className: "notification-custom-action", onClick: onAction, variant: btnVariant, size: "tiny", children: action })), _jsx("span", { className: "notification-close", onClick: onCloseClickWrapper, children: IconFactory('Remove') })] })] }));
}
export default Notification;
Notification.propTypes = {
    closeToast: PropTypes.func,
    indication: PropTypes.oneOf(Object.values(INDICATION)).isRequired,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]).isRequired,
    description: PropTypes.string,
    action: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    btnVariant: PropTypes.string,
    onCloseClick: PropTypes.func,
    descriptionInTooltip: PropTypes.bool,
    showOverflow: PropTypes.bool,
    creditsCharged: PropTypes.number,
};
Notification.defaultProps = {
    className: '',
    btnVariant: 'text',
    descriptionInTooltip: false,
    showOverflow: false,
};
